// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"CorpDocuments__Wrapper_2M4og grid","Title":"CorpDocuments__Title_2pHKt","Description":"CorpDocuments__Description_36tpv"};